
import * as React from 'react';
import { connect } from 'react-redux';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { RequestApiResult, requestAPIActions} from 'loopback-react-request';
import { GlobalPrivateState, formatMessage } from 'src/api';
import { ProjectModel } from 'franke-trough-dependencies';
import { Button } from 'reactstrap';
import { FormGroup, Input } from 'reactstrap';
import { Redirect } from 'react-router';
import { RouterState } from 'connected-react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ProjectEditForm } from '../Edit/ProjectEditForm';
import { find as _find } from 'lodash';

import './ProjectSelect.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ProjectSelect.messages';

export interface ProjectSelectProps {
  configuration: RequestApiResult<ConfigurationModel>;
  dispatch: any;
  location: RouterState['location'];
  projects: RequestApiResult<ProjectModel[]>;
}

export interface ProjectSelectState {
  editProject: boolean;
  redirect: boolean;
}

export class ProjectSelectPartial extends React.Component<ProjectSelectProps, ProjectSelectState> {

  constructor(props: ProjectSelectProps) {
    super(props);
    this.state = {
      editProject: false,
      redirect: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitted = this.submitted.bind(this);
  }

  public render() {
    const { configuration, projects } = this.props;
    const urlAppend = this.selectedProject ? 'trough' : 'country';
    const redirectUrl = this.configurationId && `/configuration/${this.configurationId}/${urlAppend}`;
    const currentUrl = this.props.location.pathname;
    
    return (
      <div className="partial-project-select">
        {projects.result && (
          <>
            <div className="row m-0">
              <div className="col-9 col-md-10 project-select-tab"> 
                {!this.state.editProject ? (
                  <FormGroup>
                    <Input
                      className="text-center"
                      type="select"
                      name="projects"
                      id="partial_project_select"
                      value={this.selectedProject || 'none'}
                      onChange={this.handleChange}
                      disabled={projects.result && projects.result.length === 0 || configuration.updating}
                    >
                      {projects.result && projects.result.length > 0 && (
                        <option value="none">
                          {formatMessage({...MESSAGES.projectSelectExistingProjectText})}
                        </option>
                      )}
                      {projects.result && projects.result.length === 0 && (
                        <option value="none" disabled={true}>
                          {formatMessage({...MESSAGES.projectSelectCreateProjectText})}
                        </option>
                      )}
                      {projects.result && projects.result.map((project, index) => {
                        const key = `partial_project_select_${index}_${project.id}`;
                        return (
                          <option key={key} value={project.id}>
                            {project.name}, {project.city}
                          </option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                ) : this.project && (
                  <ProjectEditForm 
                    passedProject={this.project}
                    submitted={this.submitted}
                  />
                )}
              </div>
              {this.selectedProject && (
                <div className="col-3 col-md-2 project-select-button">
                <FormGroup>
                  <Button 
                    color="link" 
                    className="form-control px-0"
                    onClick={this.handleClick}
                    title={formatMessage({...MESSAGES.projectSelectButtonTitle})}
                  >
                    {!this.state.editProject ? (
                      <span className="icon-svg"><FontAwesomeIcon icon={faPen} /></span>
                    ) : (
                      <span className="icon-svg"><FontAwesomeIcon icon={faTimes} /></span>
                    )}
                  </Button>
                </FormGroup>
              </div>
              )}
              {!this.selectedProject && (
                <></>
              )}
            </div>
            {!this.state.editProject && (
              <div className="row m-0">
                <div className="col-12 text-center">
                  <Button
                    className="register-button mt-3"
                    disabled={!this.selectedProject || configuration.updating || this.selectedProject && this.selectedProject.length === 0 ? true : false}
                    onClick={this.handleSubmit}
                    type="submit"
                  >
                    <FormattedMessage {...MESSAGES.projectSelectButton} />
                  </Button>
                  {!this.selectedProject && (
                    <a 
                      className="w-100 d-block mt-4 without-object"
                      onClick={this.handleSubmit}
                    >
                      <FormattedMessage {...MESSAGES.projectSelectWithout} />
                    </a>
                  )}
                </div>
              </div>
            )}
          </>
        )}
        {this.state.redirect && redirectUrl && redirectUrl !== currentUrl && (
          <Redirect to={redirectUrl} />
        )}
      </div>
    );
  }

  private get configurationId(): string | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result && configuration.result.id;
  }

  private dispatchConfiguration(projectId: string | null) {
    const { configuration } = this.props;
    if (projectId !== 'none' || projectId.length > 0) {
      this.props.dispatch(requestAPIActions.load(
        'configuration', {
          url: `/Configurations/${configuration.result && configuration.result.id}`,
          options: {
            method: 'PATCH',
            data: {
              projectId: projectId
            }
          },
        },
        true
      ));
    }
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement;
    const value = target.value === 'none' ? null : target.value;
    
    this.dispatchConfiguration(value);
  }

  private handleClick(): void {
    this.setState({
      editProject: !this.state.editProject,
    });
  }

  private handleSubmit(): void {
    this.setState({
      redirect: true
    });
  }

  private get project(): ProjectModel | undefined {
    if (!this.selectedProject) {
      return;
    }
    const projects = this.props.projects && this.props.projects.result;
    if (!projects) {
      return;
    }
    return _find<ProjectModel>(projects, (item: ProjectModel) => item.id === this.selectedProject);
  }

  private get selectedProject(): string | undefined {
    const { configuration } = this.props;
    return configuration.result && configuration.result.projectId;
  }

  private submitted(success: boolean) {
    if (success) {
      this.setState({
        editProject: false,
      });
    }
  }
}

export const ProjectSelect = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  location: state.router.location,
  projects: state.projects,
}))(ProjectSelectPartial);

export default ProjectSelect;